<app-loading type='LOADING_DATA' *ngIf="this.api_result.Posting"></app-loading>

<div class="ui-g" *ngIf="!this.api_result.Posting && this.api_result.PromiseResult.success">

    <div class="ui-g-12 notranslate">
        <h2 class="boldnlabel">Patient Medical History</h2>

        <ng-container *ngIf="!this.is_edit">
            <div class="ui-g">
                <div class="ui-g-12 edit-medical-history-button">
                    <p-button type="button" [style]="{'margin-left':'5px','margin-right':'5px','float':'right'}"
                        (click)="this.edit()" [disabled]="this.api_result.Posting" label="Edit"
                        styleClass="p-button-lg ui-button-warning" icon="pi pi-pencil"></p-button>
                </div>
            </div>
            <div class="ui-g">

                <div class="ui-g-12 form-group basiccard">
                    <div class="ui-g-12">
                        <div class="ui-g-12 ui-lg-4">
                            <label class="boldmedicalhistory" for="firstname">Chief Medical Complaint:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-8">
                            <p [innerHTML]="this.getNAForEmptyString(condition_description)"></p>
                        </div>
                    </div>
                    <div class="ui-g-12">
                        <div class="ui-g-12 ui-lg-4">
                            <label class="boldmedicalhistory" for="firstname">Medical Conditions:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-8">
                            <p
                                [innerHTML]="this.getNAForEmptyString(this.medicalHistoryApiData.currentMedicalProblems)">
                            </p>
                        </div>
                    </div>
                    <div class="ui-g-12">
                        <div class="ui-g-12 ui-lg-4">
                            <label class="boldmedicalhistory" for="firstname">Past Medical History:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-8">
                            <p>
                                {{this.getStringPastMedicalHistory(this.medicalHistoryApiData.past_medical_history_data)}}
                            </p>
                        </div>
                    </div>
                    <div class="ui-g-12">
                        <div class="ui-g-12 ui-lg-4">
                            <label class="boldmedicalhistory" for="firstname">Past Surgical History:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-8">
                            <p
                                [innerHTML]="this.getNAForEmptyString(this.medicalHistoryApiData.past_surgical_history_data)">
                            </p>
                        </div>
                    </div>
                    <div class="ui-g-12">
                        <div class="ui-g-12 ui-lg-4">
                            <label class="boldmedicalhistory" for="firstname">Medications:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-8">
                            <p *ngFor="let med of this.medicalHistoryApiData.medications">
                                <span class="boldmedicalhistory">Name: </span>{{med.name}}<br>
                                <span class="boldmedicalhistory"> Dose: </span>{{med.dose}}<br>
                                <span class="boldmedicalhistory"> Times Per day:</span>
                                <span [innerHTML]="this.getNAForEmptyString(med.times_per_day)"></span><br>
                                <span class="boldmedicalhistory"> Instructions: </span>
                                <span [innerHTML]="this.getNAForEmptyString(med.instructions)"></span>
                            </p>
                            <p *ngIf="this.medicalHistoryApiData.medications.length==0">
                                {{this.getNAForEmptyArray(this.medicalHistoryApiData.medications)}}
                            </p>
                        </div>
                    </div>
                    <div class="ui-g-12">
                        <div class="ui-g-12 ui-lg-4">
                            <label class="boldmedicalhistory" for="allergies">Allergies:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-8">
                            <p *ngFor="let aler of this.medicalHistoryApiData.allergies">
                                <span class="boldmedicalhistory">Name: </span>{{aler.name}}<br><span
                                    class="boldmedicalhistory"> Reaction: </span>{{aler.reaction}}
                            </p>
                            <p *ngIf="this.medicalHistoryApiData.allergies.length==0">
                                {{this.getNAForEmptyArray(this.medicalHistoryApiData.allergies)}}
                            </p>
                        </div>
                    </div>

                    <div class="ui-g-12">
                        <div class="ui-g-12 ui-lg-4">
                            <label class="boldmedicalhistory" for="firstname">Social History:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-8">
                            <p [innerHTML]="this.getNAForEmptyString(social_history_data)"></p>
                        </div>
                    </div>

                    <div class="ui-g-12">
                        <div class="ui-g-12 ui-lg-4">
                            <label class="boldmedicalhistory" for="firstname">Family History:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-8">
                            <p *ngFor="let i of this.medicalHistoryApiData.family_history">
                                <span class="boldmedicalhistory">{{i.name+': '}}</span>
                                <span [innerHTML]="this.getNAForEmptyString(i.data.join(', '))"></span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="this.is_edit">
            <app-medical-history-ui-edit [patientData]="this.medicalHistoryApiData"
                (onSaveClick)="this.processTheData($event)">
            </app-medical-history-ui-edit>

            <div class="ui-g">
                <div class="ui-g-12 edit-medical-history-button">
                    <p-progressSpinner *ngIf="this.api_result.Posting"
                        [style]="{'width': '25px', 'height': '25px', 'vertical-align' : 'middle'}" strokeWidth="6">
                    </p-progressSpinner>
                    <p-button *ngIf="this.is_edit" type="button"
                        [style]="{'margin-left':'5px','margin-right':'5px','float':'right'}" (click)="this.cancel()"
                        [disabled]="this.api_result.Posting" label="Cancel" styleClass="p-button-lg ui-button-danger"
                        icon="pi pi-times"></p-button>
                    <p-button *ngIf="this.is_edit" type="button"
                        [style]="{'margin-left':'5px','margin-right':'5px','float':'right'}" (click)="this.save()"
                        [disabled]="this.api_result.Posting" label="Save" styleClass="p-button-lg ui-button-success"
                        icon="pi pi-save"></p-button>
                </div>
            </div>
        </ng-container>
    </div>
</div>

<app-error-messages [api_result]="this.api_result"></app-error-messages>